import { BaseModel } from "../Generics/BaseModel"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"

export class AdminEmployee extends BaseModel {
  adminEmployeeId: number

  username: string

  password: string

  name: string

  email: string

  status: EEnableStatusType

  isRoot: boolean

  permissions: string[]

  constructor(data: Partial<AdminEmployee> = {}) {
    super()

    this.adminEmployeeId = data.adminEmployeeId ?? -1

    this.username = data.username ?? ""

    this.password = data.password ?? ""

    this.name = data.name ?? ""

    this.email = data.email ?? ""

    this.status = data.status ?? EEnableStatusType.Active

    this.isRoot = data.isRoot ?? false

    this.permissions = data.permissions ?? []
  }
}
